<template>
  <div
    class="pa-2 pa-md-4 flex-grow-1 align-center justify-center d-flex flex-column"
  >
    <div class="layout-content ma-auto w-full">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  computed: {}
};
</script>

<style scoped>
.layout-side {
  width: 420px;
}

.layout-content {
  max-width: 480px;
}
</style>
